import { styled } from "../../theme";

export const H1 = styled.h1<{ fontColor?: string }>`
  font-family: ${({ theme }) => theme.font.styledFont};
  font-weight: normal;
  font-size: 3em;
  text-align: center;
  margin: 0;

  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    font-size: 1.6em;
    max-width: inherit;
  }
`;

export const H2 = styled.h2<{ fontColor?: string }>`
  color: ${({ fontColor }) => (fontColor ? fontColor : "")};
  font-family: ${({ theme }) => theme.font.styledFont};
  font-weight: bold;
  font-size: 2em;
  margin: 0;

  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    font-size: 1.5em;
    max-width: inherit;
  }
`;
